import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-595a55a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "flex flex-col fl-1 m-b-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Наименование рекламной площадки", -1))
const _hoisted_5 = { class: "flex flex-col fl-1 m-b-8" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Slug", -1))
const _hoisted_7 = { class: "flex flex-col fl-1 m-b-8" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-b-12" }, "Рекламная площадка является платформой:", -1))
const _hoisted_9 = { class: "fl m-b-8" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "yes",
  class: "p-l-4"
}, "Да", -1))
const _hoisted_11 = { class: "fl" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "no",
  class: "p-l-4"
}, "Нет", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Паттерны", -1))
const _hoisted_14 = { class: "flex flex-center" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-trash f-s-12" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]

import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { usePlatformsStore } from "@/store/dictionaries/platforms";

import InputText from "primevue/inputtext";
import { arePlatformFieldsValid } from "@/services/dictionaries/platforms";
import SceletonInput from "@/shared/forms/SceletonInput.vue";
import RadioButton from "primevue/radiobutton";

import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformCreateForm',
  emits: ["setLoading"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const route = useRoute();
const router = useRouter();
const store = usePlatformsStore();

const platform = ref({
  name: "",
  is_platform: "1",
  slug: "",
  patterns: [{ name: "" }],
});

const isInvalidForm = ref(false);
const isPlatformSetted = computed(() => {
  return Boolean(route.params.id);
});
const isLoadingData = ref(false);

const reload = () => {
  if (isPlatformSetted.value) {
    const platformSlug = route.params.id;
    isLoadingData.value = true;
    store
      .getPlatform(platformSlug)
      .then((platformClone) => {
        if (platformClone) {
          platform.value.name = platformClone.name;
          platform.value.slug = platformClone.slug;
          platform.value.is_platform = platformClone.is_platform ? "1" : "0";
          platform.value.patterns = platformClone.patterns.map((e: string) => {
            return {
              name: e,
            };
          });
        }
      })
      .finally(() => {
        isLoadingData.value = false;
      });
  }
};

onMounted(() => {
  reload();
});

const createPlatform = () => {
  const patternNames: string[] = platform.value.patterns.map(
    (pattern) => pattern.name
  );

  const platformToServer = {
    slug: platform.value.slug,
    name: platform.value.name,
    patterns: patternNames,
    is_platform: platform.value.is_platform == "1" ? true : false,
  };

  if (!arePlatformFieldsValid(platformToServer)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены.`
    );
    return;
  }
  emit("setLoading", true);
  if (!isPlatformSetted.value) {
    performPlatformAction(() => store.createPlatform(platformToServer));
  } else {
    performPlatformAction(() =>
      store.updatePlatform(platformToServer, route.params.id)
    );
  }
};

const performPlatformAction = (action: any) => {
  const handleSuccess = () => {
    router.push({ name: "platforms" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  action()
    .then(handleSuccess)
    .catch((err: any) => {
      if (err.response && err.response.status == 409)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
      if (err.response && err.response.status == 403)
        rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
    })
    .finally(() => {
      emit("setLoading", false);
    });
};

const addPattern = (idx: number) => {
  platform.value.patterns.splice(idx + 1, 0, { name: "" });
};

const deletePattern = (idx: number) => {
  platform.value.patterns.splice(idx, 1);
};

__expose({
  createPlatform,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputText), {
              id: "name",
              placeholder: "Введите значение",
              modelValue: platform.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((platform.value.name) = $event)),
              invalid: isInvalidForm.value && platform.value.name == ''
            }, null, 8, ["modelValue", "invalid"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputText), {
              disabled: isPlatformSetted.value,
              id: "name",
              placeholder: "Введите значение",
              modelValue: platform.value.slug,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((platform.value.slug) = $event)),
              invalid: isInvalidForm.value && platform.value.slug == ''
            }, null, 8, ["disabled", "modelValue", "invalid"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(RadioButton), {
                modelValue: platform.value.is_platform,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((platform.value.is_platform) = $event)),
                inputId: "yes",
                name: "isPlatform",
                value: "1"
              }, null, 8, ["modelValue"]),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(RadioButton), {
                modelValue: platform.value.is_platform,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((platform.value.is_platform) = $event)),
                inputId: "no",
                name: "isPlatform",
                value: "0"
              }, null, 8, ["modelValue"]),
              _hoisted_12
            ])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _hoisted_13,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platform.value.patterns, (pattern, idxr) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex flex-col fl-1 m-b-8 role-container",
          key: `pattern-${idxr}`
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(InputText), {
              id: "name",
              class: "fl-1",
              placeholder: "Введите значение",
              modelValue: pattern.name,
              "onUpdate:modelValue": ($event: any) => ((pattern.name) = $event),
              invalid: isInvalidForm.value && pattern.name == ''
            }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"]),
            _createElementVNode("div", {
              class: _normalizeClass(["group-button-container role flex", [idxr != platform.value.patterns.length - 1 ? 'hidden' : '']])
            }, [
              (platform.value.patterns.length > 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "delete-button flex flex-center m-l-8",
                    onClick: ($event: any) => (deletePattern(idxr))
                  }, _hoisted_17, 8, _hoisted_15))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "add-button flex flex-center",
                onClick: ($event: any) => (addPattern(idxr))
              }, _hoisted_20, 8, _hoisted_18)
            ], 2)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})